import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public isBrowser: boolean;
  isLoggedIn = false;
  userDetails: any;
  public cartquantity = 0;
  addonscheck = false;

  constructor(@Inject(PLATFORM_ID) platformId: string) {
    if (isPlatformBrowser(platformId)){
      this.isBrowser = true;
      if (localStorage.getItem('userDetails')){
        this.isLoggedIn = true;
        this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
      }
      else{
        this.isLoggedIn = false;
      }
      if (Number(localStorage.getItem('cartquantity')) >= 0 && localStorage.getItem('cartquantity') !== null) {
        this.cartquantity = Number(localStorage.getItem('cartquantity')) + 1;
      } else {
        this.cartquantity = 0;
      }

    } else {
      this.isBrowser = false;
    }
  }
}
